import axiosInstance from '../default-setup/AxiosInstance';

export default {
    fetchSearch: function(payload) {
        const requestUrl = `/search`;

        return axiosInstance.post(requestUrl, payload);
    },
};
